var FcPaginatorModule = /** @class */ (function () {
    function FcPaginatorModule() {
    }
    return FcPaginatorModule;
}());
export { FcPaginatorModule };
